"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const react_native_1 = require("react-native");
const RadioButton_style_1 = require("./RadioButton.style");
function RadioButton({ isSelected, label, style = [], disabled = false, onPress, }) {
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { activeOpacity: 0.75, disabled: disabled, style: [...[RadioButton_style_1.styles.row], ...style], onPress: () => onPress() },
        react_1.default.createElement(react_native_1.View, { style: RadioButton_style_1.styles.radioButton }, isSelected && react_1.default.createElement(react_native_1.View, { style: RadioButton_style_1.styles.active })),
        react_1.default.createElement(index_1.Text, { style: [RadioButton_style_1.styles.label] }, label)));
}
exports.RadioButton = RadioButton;
